module.exports = __webpack_public_path__ + "img/burger.2d806637.svg";